import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Grid, Typography, withWidth} from '@material-ui/core';
import {isWidthUp} from "@material-ui/core/withWidth";
import {Fade} from 'react-reveal';

const imagePath = "/images/payments.svg";
const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing.unit * 12,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing.unit * 8,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  tagLine: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
    paddingBottom: theme.spacing.unit * 2
  },
  image: {
    maxWidth: '100%',
  },
  icon: {
    height: 40,
    width: 40,
  },
  bottomTextContainer: {
    paddingTop: theme.spacing.unit * 6
  },
  description: {
    color: theme.palette.text.secondary,
    textAlign: 'center'
  },
  bottomDescription: {
    color: theme.palette.text.secondary
  }
});

const Payments = withStyles(styles)(({classes, width}) => (
  <div className={classes.root}>
    <Grid container direction="column" justify="space-evenly" alignItems="center">
      <Fade bottom duration={1500} cascade={true} distance="100px">
        <Grid item>
          <Typography variant="caption" color="secondary" gutterBottom className={classes.tagLine}>
            Payments
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} gutterBottom align="center" color="inherit">
            Crypto
            <span style={{fontWeight: 'bold'}}> Payment</span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" className={classes.description}>
            CryptX Payments is an easy way for you to pay people across the world with ZERO transaction fees.
          </Typography>
          <Typography variant="body2" className={classes.description}>
            Bundled with an Address Book, Secure QR interface and multi factor authentication, Crypto payments have
            never
            been cheaper!
          </Typography>
        </Grid>
        <Grid item>
          <object data={imagePath} className={classes.image}/>
        </Grid>
        <Grid item className={classes.bottomTextContainer}>
          <Grid container direction="row" justify="center" alignItems="stretch" spacing={16}>
            <Grid item xs={12} sm={12} md={4}>
              <Grid container direction="row">
                <Grid item xs={2}>
                  <img src="/images/icons/payments/inter-crypto.svg" alt="Icon" className={classes.icon}/>
                </Grid>
                <Grid item xs={10}>
                  <Typography color="inherit" variant="h6">Inter Crypto Payments</Typography>
                  <Typography color="inherit" gutterBottom variant="body2" className={classes.bottomDescription}>
                    Make fast and secure on and off chain payments using Cryptocurrencies
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Grid container direction="row">
                <Grid item xs={2}>
                  <img src="/images/icons/payments/zero-transaction-fees.svg" alt="Icon" className={classes.icon}/>
                </Grid>
                <Grid item xs={10}>
                  <Typography color="inherit" variant="h6">0 Transaction Fees</Typography>
                  <Typography color="inherit" variant="body2" className={classes.bottomDescription}>
                    There are no transaction fees for off chain homogenous crypto to crypto transactions.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Grid container direction="row">
                <Grid item xs={2}>
                  <img src="/images/icons/payments/preferred-currency.svg" alt="Icon" className={classes.icon}/>
                </Grid>
                <Grid item xs={10}>
                  <Typography color="inherit" variant="h6">Preferred Currency</Typography>
                  <Typography color="inherit" variant="body2" className={classes.bottomDescription}>
                    Set your wallet’s preferred currency, any payment coming to your wallet will be automatically traded
                    and converted for you.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </Grid>
  </div>
));

export default withWidth()(Payments);
